<div class="heading">
  <div>
    <h2>پایداری سیستم شارژ</h2>
    <small>ارزیابی آماری مبتنی بر الگوی همین خودرو</small>
  </div>
  <span *ngIf="assessment" class="status">{{ view.status || 'وضعیت مشخص نشده' }}</span>
</div>

<ng-container *ngIf="assessment; else empty">
  <p *ngIf="view.note" class="assessment-note">{{ view.note }}</p>
  <div class="metrics">
    <div class="metric-row" *ngFor="let row of view.rows">
      <span>{{ row.label }}</span>
      <strong dir="ltr" *ngIf="row.value != null; else unavailable">{{ row.value | number:row.digits:'en-US' }}{{ row.unit ? ' ' + row.unit : '' }}</strong>
    </div>
  </div>
  <p class="hint">این نتیجه تشخیص قطعی خرابی دینام نیست؛ هشدارها نیازمند بررسی کیفیت سنسور و تداوم نوسان هستند.</p>
</ng-container>

<ng-template #empty><div class="empty" role="status">اطلاعاتی برای ارزیابی پایداری سیستم شارژ موجود نیست.</div></ng-template>
<ng-template #unavailable><span class="unavailable" aria-label="اطلاعات موجود نیست">—</span></ng-template>
